import { CheckCircle2, XCircle } from "lucide-react";

const without = [
  "Generic garden center plants",
  "Little wildlife support",
  "Constant guesswork and replanting",
];

const withPlan = [
  "Regionally appropriate native plants",
  "Butterflies, bees, and songbirds return",
  "A planting strategy you can trust",
];

const EcosystemBeforeAfterSection = () => {
  return (
    <section className="py-14 md:py-20">
      <div className="container max-w-4xl">
        <div className="text-center mb-10">
          <h2 className="font-display text-2xl md:text-3xl font-bold mb-3">
            From Guesswork to a Living Ecosystem
          </h2>
          <p className="text-sm md:text-base text-muted-foreground max-w-xl mx-auto">
            See the difference between a generic plant list and a regionally validated native plan.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-5">
          <div className="rounded-2xl border border-border/40 bg-card p-6">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground mb-4">
              Without a Plan
            </h3>
            <ul className="space-y-3">
              {without.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm leading-relaxed">
                  <XCircle className="h-4 w-4 text-muted-foreground mt-0.5 shrink-0" />
                  <span className="text-foreground/80">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-primary/30 bg-primary/5 p-6">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-primary mb-4">
              With Frog Knows Natives
            </h3>
            <ul className="space-y-3">
              {withPlan.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm leading-relaxed">
                  <CheckCircle2 className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                  <span className="text-foreground font-medium">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <p className="text-center text-xs text-muted-foreground mt-8">
          Regionally validated across the lower 48 · Built using native-range and ecoregion matching
        </p>
      </div>
    </section>
  );
};

export default EcosystemBeforeAfterSection;
